"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetUsageGranularity = exports.BillingStatus = exports.PlanStatus = exports.UserStatus = void 0;
exports.UserStatus = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
};
exports.PlanStatus = {
    unknown: 'unknown',
    ok: 'ok',
    in_grace_period: 'in_grace_period',
    suspended: 'suspended',
};
exports.BillingStatus = {
    unknown: 'unknown',
    ok: 'ok',
    in_grace_period: 'in_grace_period',
    missed: 'missed',
};
exports.GetUsageGranularity = {
    month: 'month',
};
